import 'babel-polyfill';
import SVGSpritesheet from "./libs/svg-spritesheet-handler";
import App from "./app";
import "whatwg-fetch";

window.addEventListener('load', () => {
	new App(document.body);
	new SVGSpritesheet;
});
